var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useState } from "react";
import { Redirect, Route, useHistory } from "react-router";
import { UserContext, } from "../components/Context/UserContext";
import Http from "../Http";
import * as Endpoint from "../Http";
import Loading from "../components/pages/Loading";
import * as Routes from "../Routes";
const PrivateRoute = (_a) => {
    var { component: Component } = _a, rest = __rest(_a, ["component"]);
    const history = useHistory();
    const { user: isAuthenticated, setUser } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!Component)
            return;
        if (!isAuthenticated) {
            Http.get(Endpoint.USER)
                .then((res) => {
                setUser(res.data);
                setLoading(false);
            })
                .catch(() => {
                setLoading(false);
                history.push(Routes.LOGIN);
            });
        }
        else {
            setLoading(false);
        }
    }, []);
    if (!Component)
        return null;
    return loading ? (React.createElement(Loading, null)) : (React.createElement(Route, Object.assign({}, rest, { render: (props) => isAuthenticated ? (React.createElement(Component, Object.assign({}, props))) : (React.createElement(Redirect, { to: {
                pathname: Routes.LOGIN,
                state: { from: props.location },
            } })) })));
};
export default PrivateRoute;
